const zhCN = {
  HEADER_TITLE: "2020年第三季",
  PREVIOUS_ISSUES: "其他期数",
  LINK_REIT: "领展",
  CHANNEL_823: "823频道",
  HOME: "主页",
  CEOS_VIEWS: "领航视野",
  CORPORATE_NEWS: "企业资讯",
  FEATURE_STORIES: "专题故事",
  LINK_TOGETHER_INITIATIVES: "爱•汇聚",
  THE_LINK_MOMENTS: "领展时光",
  CLOSE: "收起",
  MENU: "选单",
  COPYRIGHT_DISCLAIMER: "免责声明及使用条款",
  ALL_RIGHT_RESERVED: "© 领展资产管理有限公司，版权所有，不得转载。",
  LINKEDIN: "领展 LinkedIn",
  TWITTER: "领展 Twitter",
  FACEBOOK: "领展爱‧汇聚计划 Facebook",
  INSTAGRAM: "领展 Instagram",
  YOUTUBE: "领展 YouTube",
  WEIBO: '"领展房地产" 微博',
  WECHAT: '"领展房地产" 微信',
  SCAN_IN_WECHAT: "微信扫一扫",
  LINKS_WECHAT_PAGE: "「领展房地产」 微信专页",
  LINKS_WEIBO_PAGE: "「领展房地产」 微博专页",
  COVER: "封面故事",
  BACK_TO_TOP: "置顶",
  TOP: "置顶",
  LINK_REIT_WECHAT_QR_CODE: "「領展房地產」 微信二维码",
  STORY1: "实习计划<br/>大改造",
  STORY2: "人力资源<br/>创业家",
  STORY3: "非一般暑假",
  COVER_IMG_TITLE: "培育职场新星",
  READ_MORE: "阅读更多",
}
export default zhCN
